import request, { ApiResponse } from './request';

export function uploadImage(file: File): Promise<ApiResponse<{ url: string; key: string }>> {
  const formData = new FormData();
  formData.append('file', file);

  // 不要手动设置 Content-Type，让 axios 自动添加 multipart boundary
  // 上传单独放宽超时（全局 10s 对弱网上传太短）
  return request.post('/upload/image', formData, { timeout: 60000 });
}
